import { render, staticRenderFns } from "./PortfolioModern.vue?vue&type=template&id=8ff56f84&scoped=true&"
import script from "./PortfolioModern.vue?vue&type=script&lang=js&"
export * from "./PortfolioModern.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioModern.vue?vue&type=style&index=0&id=8ff56f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff56f84",
  null
  
)

export default component.exports